import { Component, Input } from '@angular/core'
import { Observable } from 'rxjs'
import { AppProgressbarState } from '../../models/interfaces/app-progressbar-state.interface'
import { TranslateModule } from '@ngx-translate/core'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { CommonModule } from '@angular/common'

@Component({
   selector: 'app-basic-progressbar',
   templateUrl: './app-progressbar.component.html',
   styleUrls: ['./app-progressbar.component.scss'],
   standalone: true,
   imports: [CommonModule, MatProgressBarModule, TranslateModule]
})
export class AppProgressbarComponent {
   @Input() progress$?: Observable<AppProgressbarState | undefined>
}
